import { useQuery } from "@tanstack/react-query";
import { getPosts } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch blog posts with optional filters
 * @param {Object} params - Query parameters
 * @param {number} params.category_id - Filter by category
 * @param {number} params.tag_id - Filter by tag
 * @param {boolean} params.is_featured - Featured posts only
 * @param {string} params.search - Search in title
 * @param {number} params.per_page - Items per page
 * @param {number} params.page - Page number
 */
export function useGetPosts(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["posts", i18next.language, params],
        queryFn: () => getPosts(params),
        retry: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        cacheTime: 1000 * 60 * 10, // 10 minutes
    });

    const posts = data?.data?.data || [];
    const meta = data?.data?.meta || null;

    return { isLoading, error, posts, meta, refetch };
}
